export const setTemplates = (state, payload) => state.templates = payload;

export const setLsTemplates = (state, payload) => state.lsTemplates = payload;

export const removeTemplateById = (state, id) => {
  state.templates = state.templates.filter(item => item.id !== id);
}

export const setCategoriesTree = (state, payload) => state.categoriesTree = payload;

export const setselectedCategory = (state, payload) => state.selectedCategory = payload;

export const setkeyword = (state, payload) => state.keyword = payload;